import React, { FC } from "react";
import { sanitizeHtml } from "src/utils/sanitizeHtml";

interface SafeHTMLProps {
  html: string | null | undefined;
  className?: string;
  tag?: keyof JSX.IntrinsicElements;
}

export const SafeHTML: FC<SafeHTMLProps> = ({
  html,
  className,
  tag: Tag = "div",
}) => {
  const sanitized = sanitizeHtml(html);

  if (!sanitized) return null;

  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};
